import React, { useContext, useEffect } from "react";
import { allProjects } from "../../projectConfig";
import { useNavigate } from "react-router-dom";
import { StateContext } from "../../../Context/Context";

export default function Projects() {
  const navigate = useNavigate();
  // eslint-disable-next-line
  const { state, setState } = useContext(StateContext);

  useEffect(() => {
    setState({ ...state, field: "project" });
    // eslint-disable-next-line
  }, []);

  return (
    <div className="mt-[80px] md:mt-[120px]">
      <div className="d-flex flex-column text-center">
        <h1 className="contactH">
          <span className="otherH">&lt;</span>
          <span className="getH" data-clip="Projects">
            Projects
          </span>
          <span className="otherH"> /&gt;</span>
        </h1>
        <p className="lead text-black/70 dark:text-white/70">Here are some amazing projects I have worked on</p>
      </div>
      <div className="project-cont grid mt-6 gap-3 grid-cols-2 md:!gap-5 md:grid-cols-3 2xl:grid-cols-4 justify-center items-center">
        {allProjects.map((each, index) => {
          return (
            <div
              className="h-[140px] md:h-[280px] cursor-pointer"
              key={each.id}
              onClick={() => {
                setState({ ...state, num: index });
                navigate("/projects/details");
              }}
            >
              <div className="flip-card rounded-lg">
                <div className="flip-card-front">
                  <img
                    className="img-fluid !rounded-none md:!rounded-[10px] object-cover"
                    src={each.images[0]}
                    alt=""
                  />
                </div>
                <div className="flip-card-back">
                  <img
                    className="img-fluid !rounded-none md:!rounded-[10px] object-cover"
                    src={each.images[1]}
                    alt=""
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
